import React from 'react';

const FlipBadge = ({ title, backText }) => {
  return (
    <div className='flip-badge'>
      <div className='flip-badge-inner'>
        <div className='flip-badge-front'>
          <h5 className='c-dark'>{title}</h5>
        </div>
        <div className='flip-badge-back'>
          <h5 className='c-dark'>{backText}</h5>
        </div>
      </div>
    </div>
  );
};

export default FlipBadge;